import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateUser from '../../components/users/EditCreateUser'
import DeactivateUser from '../../components/users/DeactivateUser'
import { can } from '../../helpers/auth'
import NoPermission from '../pages/noPermission'
import { toast } from 'react-toastify'
import { useListUsersQuery } from '../../redux/Api/UserManagment/uMUsersApiSlice'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'

function Users () {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const { data, isLoading, error, isFetching } = useListUsersQuery({
    page: pagination.current,
    page_size: pagination.pageSize,
    search: search || undefined,
    ...filters
  })

  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)
  const [deactivate, setDeactivate] = useState(false)
  const [holder, setHolder] = useState()

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      filter: true,
      filterType: 'text'
    },

    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'Is Active',
      dataIndex: 'is_active',
      key: 'is_active',
      render: text => (text ? 'Yes' : 'No')
    },
    {
      title: 'Is Admin',
      dataIndex: 'is_superuser',
      key: 'is_superuser',
      render: text => (text ? 'Yes' : 'No')
    },
    {
      title: 'Is Staff',
      dataIndex: 'is_staff',
      key: 'is_staff',
      render: text => (text ? 'Yes' : 'No')
    }
  ]

  if (can('change_user')) {
    columns.push({
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <button
            className='btn btn-outline-theme'
            onClick={() => handleEdit(record)}
          >
            Edit
          </button>
          <button
            className='btn btn-outline-light'
            onClick={() => handleDeactivate(record)}
          >
            {record.is_active ? 'Deactivate' : 'Activate'}
          </button>
        </div>
      )
    })
  }

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }
  const handleDeactivate = record => {
    setHolder(record)
    setDeactivate(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  const context = useContext(AppSettings)
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return function cleanUp () {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [])

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  if (!can('view_user')) {
    return <NoPermission />
  }

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {edit ? (
        <EditCreateUser
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          user={holder}
        />
      ) : null}
      {create ? (
        <EditCreateUser
          state={'create'}
          open={create}
          setOpen={setCreate}
          user={null}
        />
      ) : null}
      {deactivate ? (
        <DeactivateUser
          open={deactivate}
          setOpen={setDeactivate}
          user={holder}
        />
      ) : null}
      <div className='flex mb-4'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <button
          className='btn btn-outline-theme ml-auto mb-4'
          onClick={() => setCreate(true)}
        >
          Add New User
        </button>
      </div>
      <br />
      {data ? (
        <ReusableTable
          columns={columns}
          data={data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      ) : null}
    </div>
  )
}

export default Users
